<template>
    <div id="inspire" style="word-break: normal">
        <v-container fluid class="pt-0 pb-0">
            <v-row justify="center" class="headerStyle">
                <v-col md="4"
                       sm="5"
                       class="text-left">
                    <img src="@/assets/logo@2x.png" class="heardImg" alt="">
                    <span>INFINITEPAY</span>
                </v-col>
                <v-col
                        md="4"
                        sm="5"
                        class="text-right">
                    <img src="@/assets/dianhua@2x.png" class="heardImg" alt="">
                    <!--<span>017-493-7240</span>-->
                    <span>170-081-2312</span>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row justify="center" no-gutters>
                <v-col
                        cols="4"
                        md="2"
                        sm="3"
                        class="text-left">
                    <img src="@/assets/logoM2M.png" style="width:3.5rem;" alt="">
                </v-col>
                <v-col
                        align-self="center"
                        cols="6"
                        md="6"
                        sm="7"
                        class="d-none d-sm-flex justify-sm-end">
                    <span class="pl-4 pr-4" v-for="item in items">
                        <v-btn text color="#000">
                            <a @click="changeHash('#'+item.id)" target="_self" class="font-weight-bold"
                               style="color:#000;text-decoration:none;">{{item.title}}</a>
                        </v-btn>
                    </span>
                    <span class="pl-4 pr-4">
                        <v-btn text color="#000">
                            <a :href="pdf.default" style="color:#000;text-decoration: none;font-weight: 700" target="_blank">POLICY</a>
                        </v-btn>
                    </span>
                    <span class="pl-4 pr-4">
                        <v-btn color="#EB8D2F" @click="goPcWeb" depressed>
                            <a style="color:#fff;text-decoration: none;font-weight: 700" target="_blank">Enter M2M Biz</a>
                        </v-btn>
                    </span>
                </v-col>
                <!--移动端时样式-->
                <v-col
                        align-self="center"
                        cols="7"
                        class="d-flex d-sm-none justify-end">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    color="#000"
                                    icon
                                    v-on="on"
                            >
                                <v-icon style="font-size:2rem;">menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item
                                    v-for="(item, index) in items"
                                    :key="index"
                                    @click="changeHash('#'+item.id)"
                            >
                                {{item.title}}
                            </v-list-item>
                            <v-list-item>
                                <a :href="pdf.default" style="color:#000;text-decoration: none;" target="_blank">POLICY</a>
                            </v-list-item>
                            <v-list-item @click="goPcWeb">
                                <a style="color:#000;text-decoration: none;" target="_blank">Enter M2M Biz</a>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="pt-0 pb-0">
            <v-row>
                <v-col
                        class="bannerLeft pt-12 pb-12"
                        cols="12"
                        sm="6">
                    <v-row
                            class="pt-12 pb-12"
                            justify-sm="end"
                            justify="center">
                        <v-col
                                xl="8"
                                lg="8"
                                md="11"
                                cols="11"
                                sm="11">
                            <v-card color="transparent"
                                    style="box-shadow: none">
                                <v-card-title class="font-weight-bold wordNormal">
                                    Let make it easy to
                                    do business anywhere!！
                                </v-card-title>
                                <v-card-text>
                                    Empowering business and streamlines business
                                    management, that simplifies your operation. With
                                    this M2M smart E-POS system will increase your
                                    REVENUE !
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn class="ma-2" @click="dialog.contact=true" outlined color="#000">
                                        Get It Today!
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col
                        class="bannerRight pt-12 pb-12"
                        cols="12"
                        sm="6">
                    <v-row style="visibility: hidden;"
                           class="pt-12 pb-12"
                           justify-lg="end"
                           justify-sm="end"
                           justify-md="end"
                           justify="center">
                        <v-col
                                xl="8"
                                lg="8"
                                md="11"
                                cols="11"
                                sm="11">
                            <v-card color="transparent">
                                <v-card-title
                                        class="font-weight-bold wordNormal">
                                    Let make it easy to do business anywhere!！
                                </v-card-title>
                                <v-card-text>
                                    Empowering business and streamlines business
                                    management, that simplifies your operation. With
                                    this M2M smart E-POS system will increase your
                                    REVENUE !
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                            @click="dialog.contact=true"
                                            class="ma-2"
                                            outlined
                                            color="#000">
                                        Get It Today!
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="background-color:#F5F5F5;" id="Features">
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    FEATURES
                </v-col>
            </v-row>
            <v-row class="d-none d-sm-flex justify-sm-end">
                <v-carousel
                        cycle
                        interval="3000"
                        height="400"
                        hide-delimiter-background
                        show-arrows
                >
                    <v-carousel-item>
                        <v-img width="100%" height="100%" contain src="@/assets/lunbo1@2x.png"></v-img>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-img width="100%" height="100%" contain src="@/assets/lunbo2@2x.png"></v-img>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-img width="100%" height="100%" contain src="@/assets/lunbo3@2x.png"></v-img>
                    </v-carousel-item>
                </v-carousel>
            </v-row>
            <v-row class="d-flex d-sm-none justify-end">
                <v-carousel
                        cycle
                        interval="3000"
                        height="200"
                        hide-delimiter-background
                        show-arrows
                >
                    <v-carousel-item>
                        <v-img width="100%" height="100%" contain src="@/assets/lunbo1@2x.png"></v-img>
                    </v-carousel-item>
                    <v-carousel-item>
                        <v-img width="100%" height="100%" contain src="@/assets/lunbo2@2x.png"></v-img>
                    </v-carousel-item>
                </v-carousel>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    VALUES ADDED
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col
                        md="3"
                        sm="6"
                        cols="12">
                    <v-hover
                            v-slot:default="{ hover }"
                    >
                        <v-card
                                class="pt-12 pb-12"
                                style="color:#000;height:100%;"
                                :elevation="hover ? 12 : 1">
                            <v-card-text>
                                <v-img
                                        position="'center left'"
                                        contain
                                        src="@/assets/customer@2x.png"
                                        height="5rem"
                                ></v-img>
                            </v-card-text>
                            <v-card-subtitle
                                    class="font-weight-black"
                                    style="color:#000;">
                                Customer Acquisition
                            </v-card-subtitle>
                            <v-card-text
                                    style="color:#000;">
                                We more than just a possystem, we
                                increase your revenue.We more than just
                                a possystem, we increase your revenue.
                                We more than just a possystem,
                                we increase your revenue.
                            </v-card-text>
                        </v-card>
                    </v-hover>

                </v-col>
                <v-col
                        md="3"
                        sm="6"
                        cols="12">
                    <v-hover
                            v-slot:default="{ hover }"
                    >
                        <v-card
                                class="pt-12 pb-12"
                                style="color:#333;height:100%;"
                                :elevation="hover ? 12 : 1">
                            <v-card-text>
                                <v-img
                                        position="'center left'"
                                        contain
                                        src="@/assets/increase@2x.png"
                                        height="5rem"
                                ></v-img>
                            </v-card-text>
                            <v-card-subtitle class="font-weight-black"
                                             style="color:#000;">
                                Increase consumer buying behaviour
                            </v-card-subtitle>
                            <v-card-text
                                    style="color:#000;">
                                Loyalty & membership program can cause
                                buyers a great deal of postpurchase
                                dissonance (anxiety) if they are unsure
                                about their purchases. Flexible
                                configuration with points, rewards,
                                vouchers, benefits.
                            </v-card-text>
                        </v-card>
                    </v-hover>

                </v-col>
                <v-col
                        md="3"
                        sm="6"
                        cols="12">
                    <v-hover
                            v-slot:default="{ hover }"
                    >
                        <v-card
                                class="pt-12 pb-12"
                                style="color:#333;height:100%;"
                                :elevation="hover ? 12 : 1">
                            <v-card-text>
                                <v-img
                                        position="'center left'"
                                        contain
                                        src="@/assets/smart@2x.png"
                                        height="5rem"
                                ></v-img>
                            </v-card-text>
                            <v-card-subtitle class="font-weight-black"
                                             style="color:#000;">
                                Smart E-POS System
                            </v-card-subtitle>
                            <v-card-text style="color:#000;">
                                Cloud-based accessibility and comprehensive
                                management tools enable work more
                                efficiently and effectively than ever before.
                            </v-card-text>
                        </v-card>
                    </v-hover>

                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="color:#fff;background-image: linear-gradient(to right, #3D3D3D, #000000)">
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    E-WALLET
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-center">
                    <span>MDR RATE:</span>
                    <span class="primary-color ma-2">0</span>
                    <span>%</span>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="11"
                       md="8"
                       sm="9"
                       class="text-center">
                    <v-img width="100%" src="@/assets/e-wallet@2x.png"></v-img>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    FUTURE VALUE ADDED SERVIXES
                </v-col>
            </v-row>
            <v-divider></v-divider>

            <template v-for="item in list">
                <v-row justify="center" align="center">
                    <v-col cols="12"
                           sm="3"
                           class="font-weight-bold">
                        {{item.title}}
                    </v-col>
                    <v-col cols="12"
                           sm="3">
                        <p v-for="str in item.content">{{str}}</p>
                    </v-col>
                    <v-col cols="12"
                           sm="3"
                           class="d-none d-sm-flex">
                        <v-img src="@/assets/FREE@2x.png" contain height="6rem"></v-img>
                    </v-col>
                    <v-col cols="12"
                           sm="3"
                           class="d-flex d-sm-none">
                        <v-img src="@/assets/FREE@2x.png" :position="'center left'" contain height="6rem"></v-img>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </template>
        </v-container>

        <v-container fluid class="gapView" id="o2o">
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    O2O TO HELP BUSINESS RUN DURING THE MCO (movement control order)
                </v-col>
            </v-row>
            <v-row justify="center" no-gutters class="pt-12 pb-12">
                <v-col cols="12"
                       sm="3"
                       class="boderStyle pa-6 pb-12"
                       style="position:relative;">
                    <div class="font-weight-bold mb-6">
                        O2O enables online ordering for everything all over Malaysia!
                    </div>
                    <div class="mb-12">
                        Not enough masks?
                        Download M2M to order your
                        protective equipment at the
                        moment!
                    </div>
                    <!--<div class="text-right d-flex flex-column align-end">-->
                    <!--<div style="width:100px;color:#273479;font-size:14px;"-->
                    <!--class="font-weight-bold">-->
                    <!--Scan QR code to download-->
                    <!--</div>-->
                    <!--<div style="width:100px;height:100px;background-color:pink;">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<img src="@/assets/pic2@2x.png"-->
                    <!--width="100%;"-->
                    <!--style="position:absolute;bottom:10px;right:0;"-->
                    <!--alt="">-->
                </v-col>

                <v-col cols="12"
                       v-show="isShowFrame"
                       style="min-height: 400px"
                       sm="6">
                    <iframe id="myframe" width="100%" height="100%" src="https://www.youtube.com/embed/_reyrSwfGTY" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="contactView" id="CONTACT">
            <v-row>
                <v-col class="text-center font-weight-bold f-s-title">
                    CONTACT US
                </v-col>
            </v-row>
            <v-row>
                <v-col
                        sm="6"
                        cols="12">
                    <v-row justify-sm="end"
                           justify="center">
                        <v-card style="width:70%;min-width:300px;" class="pb-6">
                            <v-card-subtitle class="font-weight-bold" style="color:#000;">
                                Fill in your basic information
                            </v-card-subtitle>
                            <v-card-text>
                                <v-form ref="form">
                                    <p>Business Name</p>
                                    <v-text-field
                                            label="Solo"
                                            :counter="30"
                                            :rules="[
                                            v => (v && v.length <= 30) || 'Business Name must be less than 30 characters'
                                            ]"
                                            placeholder="Business Name"
                                            v-model="basicInfo.mchtNm"
                                            clearable
                                            solo
                                    ></v-text-field>
                                    <p>Business Adress</p>
                                    <v-text-field
                                            label="Solo"
                                            placeholder="Example：31-13-08,The CEO,Lebuh Nipah 5,"
                                            :rules="[
                                            v => (v && v.length <= 200) || 'Address must be less than 200 characters'
                                            ]"
                                            solo
                                            clearable
                                            v-model="basicInfo.mchtAddb"
                                    ></v-text-field>
                                    <p>Contact Person</p>
                                    <v-text-field
                                            label="Solo"
                                            placeholder="Full Name"
                                            :rules="[
                                            v => (v && v.length <= 30) || 'FullName must be less than 30 characters'
                                            ]"
                                            clearable
                                            v-model="basicInfo.mchtContact"
                                            solo
                                    ></v-text-field>
                                    <p>Handphone</p>
                                    <v-text-field
                                            label="Solo"
                                            placeholder="0161234567"
                                            :rules="[
                                            v => (v && v.length <= 30) || 'Phone must be less than 30 characters'
                                            ]"
                                            v-model="basicInfo.mchtContactPhone"
                                            clearable
                                            solo
                                    ></v-text-field>
                                    <p>Promocode</p>
                                    <v-text-field
                                            label="Solo"
                                            placeholder="Promocode"
                                            :rules="[
                                            v => (v && v.length <= 30) || 'Phone must be less than 30 characters'
                                            ]"
                                            v-model="basicInfo.invitationCode"
                                            clearable
                                            solo
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions class="pt-0">
                                <v-btn block
                                       :loading="loading.submitLoading"
                                       dark
                                       @click="submitInfo" color="#EB8D2F">
                                    Submit
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-row>

                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="background-color:#000;color:#fff;">
            <v-row justify="center">
                <v-col cols="12" class="text-center">
                    COPYRIGHT @ 2020 INFINITEPAY SDN BHD (BRN: 1279084-A) ALL RIGHTS RESERVED
                </v-col>
                <v-col cols="12" class="text-center">
                    <img src="@/assets/dianhua@2x.png" class="heardImg" alt="">
                    <!--<span>017-493-7240</span>-->
                    <span>170-081-2312</span>
                </v-col>
            </v-row>
        </v-container>


        <v-dialog max-width="400"
                  v-model="dialog.contact">
            <v-card
                    class="pb-2">
                <v-img
                        class="white--text align-end"
                        height="200px"
                        contain
                        :position="'right center'"

                        src="@/assets/pic@2x.png"
                >
                </v-img>
                <v-card-title class="text-center wordNormal">O2O TO HELP BUSINESS RUN DURING THE PIDEMIC MCO(movement control
                    order)
                </v-card-title>
                <v-card-text class="text--primary text-center">
                    O2O enables online ordering for everything all over Malaysia!
                </v-card-text>
                <v-card-actions>
                    <v-btn block
                           dark
                           color="#EB8D2F"
                           @click="dialogBtn">CONTACT US
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog max-width="400"
                  v-model="dialog.result">
            <v-card class="pt-12 pb-12">
                <v-card-text>
                    <v-img src="@/assets/Ok@2x.png" contain height="5rem"></v-img>
                </v-card-text>
                <v-card-text class="text-center font-weight-bold"
                             style="color:#000;">
                    Submitted successfully
                </v-card-text>
                <v-card-text class="text-center mb-6"
                             style="color:#000;">
                    Thank you for your approval, our staff will reply to you later.
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            @click="closeResult"
                            block
                            dark
                            color="#EB8D2F">OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
  import {imgVerify, hospUserLogin} from '@/api/login'
  import scrypt from '@/utils/scrypt'
  import {
    submitMcht
  } from "@/api/home"

  export default {
    name: "home",
    data() {
      return {
        pdf: require('../../assets/REFUNDANDRETURNPOLICY.pdf'),
        basicInfo: {
          mchtNm: '',
          mchtAddb: '',
          mchtContact: '',
          mchtContactPhone: '',
          txnTypeNo: "2010100333",
          dataSourceFaly:'03',
          invitationCode:''
        },
        dialog: {
          contact: false,
          result: false
        },
        loading: {
          submitLoading: false
        },
        isShowFrame: false,
        list: [
          {
            title: 'Merchant Wallet',
            content: [
              'Reload  Wallet',
              'Purchase using Merchant Wallet',
              'Increase Cash Flow',
            ]
          },
          {
            title: 'Merchant to Merchant',
            content: [
              'Connected M2M Merchant',
              'Sharing each other voucher',
              'Earn Cash Back'
            ]
          },
          {
            title: 'Visa Master',
            content: [
              'Visa Card',
              'Master Card',
              'Pay Wave'
            ]
          },
          {
            title: 'E- Menu',
            content: [
              'User scan QR code for order/purchase',
              'User make payment through APP'
            ]
          },
          {
            title: 'Food Delivery Service',
            content: [
              'By using E-Menu, weprovide delivery door',
              'to door'
            ]
          },
          {
            title: 'Business to Customer(B2C)',
            content: [
              'Promote your products from offline to online',
              'Promote your products to Nationwide'
            ]
          },
        ],
        items: [
          {
            title: 'Features',
            id: 'Features'
          },
          {
            title: 'O2O',
            id: 'o2o'
          },
          {
            title: 'CONTACT US',
            id: 'CONTACT'
          }
        ],
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
      }
    },
    methods: {
      goPcWeb(){
        window.location.href='https://www.m2mbiz.com/mchtweb';
      },
      changeHash(idName) {
        document.querySelector(idName).scrollIntoView(true);
      },
      submitInfo() {
        if (this.$refs.form.validate()) {
          console.log(this.basicInfo, '用户提交的信息');
          this.loading.submitLoading = true;
          submitMcht(this.basicInfo).then(res => {
            this.loading.submitLoading = false;
            this.dialog.result = true;
          }).catch(err => {
            this.loading.submitLoading = false;
          });
        }
      },
      closeResult() {
        this.dialog.result = false;
        this.$refs.form.reset();
        document.documentElement.scrollTop = 0;
      },
      dialogBtn() {
        this.dialog.contact = false;
        this.changeHash('#CONTACT');
      },
      getQueryVariable(variable){
        var query = window.location.href;
        var vars = query.split("?");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      }
    },
    mounted() {
      console.log(this.pdf,'00000000000');
      if(!this.getQueryVariable('dataSourceFaly')){

      }else{
        this.basicInfo.dataSourceFaly=this.getQueryVariable('dataSourceFaly');
        // 从报纸渠道进来的
        this.changeHash('#CONTACT');
      }
      var iframe = document.getElementById("myframe")
      var _this = this;
      if (!iframe.attachEvent) {
        iframe.addEventListener("load", function () {
          //代码能执行到这里说明已经载入成功完毕了
          this.removeEventListener("load", arguments.call, false);
          _this.isShowFrame = true;
          //这里是回调函数
        }, false);
      } else {
        iframe.attachEvent("onreadystatechange", function () {
          //此事件在内容没有被载入时候也会被触发，所以我们要判断状态
          //有时候会比较怪异 readyState状态会跳过 complete 所以我们loaded状态也要判断
          if (iframe.readyState === "complete" || iframe.readyState == "loaded") {
            //代码能执行到这里说明已经载入成功完毕了
            //要清除掉事件
            iframe.detachEvent("onreadystatechange", arguments.callee);
            _this.isShowFrame = true;
            //这里是回调函数
          } else {

          }
        });
      }
    },
    created() {

    }
  }
</script>

<style scoped>
    @import '../../style/animate.min.css';

    .headerStyle {
        background-color: #393939;
        color: #fff;
    }

    .heardImg {
        height: 1rem;
        display: inline-block;
        position: relative;
        top: 3px;
        margin-right: 5px;
    }

    .bannerLeft {
        background-image: url('../../assets/banner1.png');
        background-size: cover;
        background-position: center right;
    }

    .bannerRight {
        background-image: url('../../assets/banner2.png');
        background-size: cover;
        background-position: center left;
    }

    .f-s-title {
        font-size: 1.5rem;
    }

    .primary-color {
        color: #F69D42;
    }

    .gapView {
        background-image: url("../../assets/o2o_bg@2x.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        min-height: 400px;
    }

    .contactView {
        background-image: url("../../assets/contact.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }

    .boderStyle {
        border: 1px solid #B9B9B9;
    }

    .wordNormal{
        word-break: normal;
    }
</style>